import { render, staticRenderFns } from "./ownerContract-upload-file.vue?vue&type=template&id=607868ea&scoped=true"
import script from "./ownerContract-upload-file.vue?vue&type=script&lang=js"
export * from "./ownerContract-upload-file.vue?vue&type=script&lang=js"
import style0 from "./ownerContract-upload-file.vue?vue&type=style&index=0&id=607868ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607868ea",
  null
  
)

export default component.exports